import React from 'react'

const LABELS_TO_SCAN = [
  'Question',
  'Title',
  'Subject',
  'Description',
  'Answer',
  'Comment',
  'Message',
]
const FILE_ARRAY = 'FileArray'
/**
 * @param piiScan is the object with all of the pii information from the scan
 */

const PIIPopup = ({ piiScan, setPIIScan }: any) => {
  const handleClick = (answer, key) => {
    const updatedPIIScan = { ...piiScan }
    if (LABELS_TO_SCAN.includes(key)) {
      updatedPIIScan[key] = {
        ...updatedPIIScan[key],
        userAnswer: answer,
      }
    } else {
      updatedPIIScan.FileArray.value[key] = {
        ...updatedPIIScan.FileArray.value[key],
        userAnswer: answer,
      }
    }
    setPIIScan(() => ({
      ...updatedPIIScan,
    }))
  }

  return (
    <section className='pii-compliance-validation'>
      <p className='text-decoration-underline'>FOUND PII RELATED DATA IN BELOW FIELDS</p>
      <ul>
        {piiScan &&
          Object.keys(piiScan).map((key) => {
            if (key === FILE_ARRAY && piiScan.FileArray) {
              return piiScan.FileArray.value.map((file, index) => {
                if (file.resultsArray?.length > 0 && !file.userAnswer) {
                  return (
                    <li key={file.value.name}>
                      {file.value.name}:{' '}
                      <span className='sourcesanspro font-13'
                        dangerouslySetInnerHTML={{ __html: file.displayText }}
                      ></span>
                      <div className='pii-compliance-btns'>
                        <a
                          className='pii-accept '
                          href='javascript:void(0)'
                          onClick={() => handleClick('Accept', index)}
                        >
                          Accept
                        </a>
                        <a
                          className='pii-ignore'
                          href='javascript:void(0)'
                          onClick={() => handleClick('Ignore', index)}
                        >
                          Ignore
                        </a>
                      </div>
                    </li>
                  )
                }
              })
            } else if (
              piiScan[key].resultsArray?.length > 0 &&
              !piiScan[key].userAnswer
            ) {
              return (
                <li key={key}>
                  {key}:{' '}
                  <span className='sourcesanspro font-13'
                    dangerouslySetInnerHTML={{
                      __html: piiScan[key].displayText,
                    }}
                  ></span>
                  <div className='pii-compliance-btns'>
                    <a
                      className='pii-accept'
                      href='javascript:void(0)'
                      onClick={() => handleClick('Accept', key)}
                    >
                      Accept
                    </a>

                    <a
                      className='pii-ignore'
                      href='javascript:void(0)'
                      onClick={() => handleClick('Ignore', key)}
                    >
                      Ignore
                    </a>
                  </div>
                </li>
              )
            }
          })}
      </ul>
    </section>
  )
}
export default PIIPopup
